import React from "react";

import {
  isProcedure,
  Procedure,
  ProcedureDetail,
  ProcValidation,
} from "../../../../application/domain/proc-management";
import {
  ProcedureIdInput,
  ProcedureNameInput,
  ProcedureTitleInput,
  ProcedureSummaryInput,
} from "../../../molecules/proc-management/form";
import { ProcedureTagsListInput } from "../../../molecules/proc-management/form/procedure-tags-list-input";
import { ProcedureDetailJurisdictionGroupNameInput } from "../../../molecules/proc-management/form/procedure-detail-jurisdiction-group-name-input";

type Props = {
  procedure: ProcedureDetail | Procedure;
  onChange: (path: (string | number)[], value: any) => void;
  disabled?: boolean;
  shouldDisplayError: boolean;
  validationErrors: ProcValidation;
};

export const SummarySection: React.FC<Props> = ({
  procedure,
  onChange,
  disabled = false,
  shouldDisplayError = false,
  validationErrors,
}) => {
  return (
    <section className="mb-5">
      <h2 className="subtitle">手続き全体に関わる情報</h2>

      {isProcedure(procedure) && (
        <ProcedureIdInput value={procedure.id} disabled />
      )}

      {isProcedure(procedure) && !!procedure?.jurisdiction?.groupId && (
        <ProcedureDetailJurisdictionGroupNameInput
          groupId={procedure.jurisdiction.groupId}
          disabled
        />
      )}

      <ProcedureNameInput
        onChange={onChange}
        basePath={["name"]}
        value={procedure.name}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.name}
      />

      <ProcedureTitleInput
        onChange={onChange}
        basePath={["title"]}
        value={procedure.title}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.title}
      />

      <ProcedureSummaryInput
        onChange={onChange}
        basePath={["summary"]}
        value={procedure.summary}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.summary}
      />
      <ProcedureTagsListInput
        value={procedure.procedureTags ?? []}
        organizationId={procedure.jurisdiction.organizationId}
        disabled={disabled}
        onChange={onChange}
        basePath={["procedureTags"]}
        shouldDisplayError={shouldDisplayError}
        validationErrors={validationErrors.procedureTags ?? []}
      />
    </section>
  );
};
